export const APP_UPDATE = {
  title: 'App Update Required',
  body: "Sorry, this version of the Stessa Rent Pay app has expired. Please download the free update, and we'll get you back to managing your portfolio!",
  buttonText: 'Update App',
};
